import React from 'react';
import { motion } from 'framer-motion';

interface SectionHeaderProps {
  label?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center' | 'right';
  theme?: 'light' | 'dark';
  className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  label,
  title,
  subtitle,
  align = 'center',
  theme = 'light',
  className = ''
}) => {
  const alignmentStyles = {
    left: 'text-left',
    center: 'text-center mx-auto',
    right: 'text-right ml-auto'
  };

  const themeStyles = {
    light: {
      label: 'text-brand-blue bg-brand-blue/10',
      title: 'text-gray-900',
      subtitle: 'text-gray-600'
    },
    dark: {
      label: 'text-brand-yellow bg-brand-yellow/20',
      title: 'text-white',
      subtitle: 'text-white/80'
    }
  };

  const styles = themeStyles[theme];

  return (
    <div className={`max-w-3xl ${alignmentStyles[align]} ${className}`}>
      {label && (
        <motion.span
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className={`inline-block px-4 py-1.5 rounded-full text-sm font-semibold mb-4 ${styles.label}`}
        >
          {label}
        </motion.span>
      )}
      
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
        className={`text-3xl md:text-4xl lg:text-5xl font-bold mb-4 ${styles.title}`}
      >
        {title}
      </motion.h2>
      
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className={`text-lg md:text-xl ${styles.subtitle}`}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
};

export default SectionHeader;

